const pillars = [
  {
    icon: "fa-solid fa-seedling",
    title: "Sustainable energy",
    body: "Leading solar farming initiatives across Africa with measurable environmental impact.",
    tint: "leaf",
  },
  {
    icon: "fa-solid fa-earth-africa",
    title: "Pan-African reach",
    body: "Operating across multiple African nations with an international investor base.",
    tint: "amber",
  },
  {
    icon: "fa-solid fa-handshake-angle",
    title: "Community impact",
    body: "Creating jobs, education and financial inclusion in the communities we serve.",
    tint: "terracotta",
  },
];

const tintMap = {
  leaf: "bg-[hsl(var(--leaf-soft))] text-[hsl(var(--leaf))]",
  amber: "bg-[hsl(var(--amber-soft))] text-[hsl(var(--terracotta))]",
  terracotta: "bg-[hsl(var(--terracotta))]/10 text-[hsl(var(--terracotta))]",
};

export default function About() {
  return (
    <section id="about" className="relative py-24 lg:py-32 bg-[hsl(var(--bg-warm))]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-6">About us</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold leading-[1.05] text-[hsl(var(--espresso))]">
              Patient capital for a <span className="italic">sunlit</span> continent.
            </h2>
            <p className="mt-6 text-lg text-[hsl(var(--fg-muted))] leading-relaxed">
              ASELU Investment Growth Limited (AIGL) is a pioneering investment firm dedicated to
              accelerating Africa's renewable energy transition while creating sustainable
              financial opportunities for investors, entrepreneurs and communities.
            </p>
            <div className="mt-10 space-y-6">
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--terracotta))] font-semibold">
                  Our mission
                </div>
                <p className="mt-2 text-[hsl(var(--espresso))] leading-relaxed">
                  We already have Off-Takers (Governments, Learning Institutions, Companies and Individuals).{" "}
                  <a
                    href="https://aigl.pro/#contact"
                    className="font-semibold text-[hsl(var(--terracotta))] hover:text-[hsl(var(--terracotta-deep))] underline decoration-[hsl(var(--amber))] decoration-2 underline-offset-4 transition-colors"
                    data-testid="mission-invest-link"
                  >
                    Invest with us today
                  </a>
                  . Mobilise capital for large-scale solar farming projects across Africa, generating
                  competitive returns while advancing clean energy, employment and financial
                  inclusion.
                </p>
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--terracotta))] font-semibold">
                  Our vision
                </div>
                <p className="mt-2 text-[hsl(var(--espresso))] leading-relaxed">
                  To be Africa's leading sustainable investment platform — powering communities
                  with clean energy, quality education and accessible financial services.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {pillars.map((p, i) => (
                <div
                  key={p.title}
                  className={`edit-card p-7 ${i === 0 ? "sm:translate-y-6" : ""} ${
                    i === 2 ? "sm:translate-y-6" : ""
                  }`}
                  data-testid={`pillar-${i}`}
                >
                  <span className={`inline-flex w-12 h-12 rounded-2xl items-center justify-center ${tintMap[p.tint]}`}>
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold">{p.title}</h3>
                  <p className="mt-2 text-[hsl(var(--fg-muted))] text-sm leading-relaxed">{p.body}</p>
                </div>
              ))}
              <div className="edit-card p-7 bg-[hsl(var(--espresso))] border-[hsl(var(--espresso))] text-white">
                <span className="inline-flex w-12 h-12 rounded-2xl items-center justify-center bg-[hsl(var(--amber))]/20 text-[hsl(var(--amber))]">
                  <i className="fa-solid fa-chart-line text-lg"></i>
                </span>
                <h3 className="mt-5 font-display text-xl font-bold">Transparent governance</h3>
                <p className="mt-2 text-white/70 text-sm leading-relaxed">
                  Regular reporting, audited financials and clear investor communication — built
                  for long-term trust.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
